<template>
	<div class=" white-bg pad20">
		<div class="flexween ">
			<div>
				<el-button type="primary">作品登记列表</el-button>
				<el-button>我的订单</el-button>
			</div>
			<div>
				<el-button @click="$router.push('/uploadpower')">申请登记</el-button>
			</div>
		</div>
		<div class="mt20">
			<ul class="workul">
				<li @click="tabliClick(index)" v-for="(item,index) in tabArr" :key="index"
					:class="{licur:tabIndex ==index}">
					<span>{{item.title}}</span><i class="num" v-if="item.num !=0">{{item.num}}</i>
				</li>
			</ul>
			<div class="mt20">
				<el-form ref="ruleForm" :model="ruleForm">
					<div class="serchbx">
						<el-form-item class="serchcn" prop="value1">
							<el-date-picker v-model="ruleForm.value1" type="daterange" range-separator="-"
								start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="serchcn" prop="input">
							<el-input v-model="ruleForm.input" placeholder="请输入作品名称"></el-input>
						</el-form-item>
						<el-form-item class="serchcn" prop="input">
							<el-input v-model="ruleForm.input" placeholder="请输入著作权人"></el-input>
						</el-form-item>
					</div>
					<div class="serchbx ">
						<el-form-item class="serchcn" prop="input">
							<el-input v-model="ruleForm.input" placeholder="请输入作品ID"></el-input>
						</el-form-item>
						<el-form-item class="serchcn" prop="value">
							<el-select v-model="ruleForm.value" placeholder="请选择作品类别">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="serchcn" prop="input">
							<el-button type="primary" plain>筛选</el-button>
							<el-button plain @click="resetForm">重置</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div>
				<div class="table_header">
					<div class="workname">作品</div>
					<div class="table_cell">著作权人</div>
					<div class="table_cell">作品类型</div>
					<div class="table_cell">状态</div>
					<div class="table_cell">操作</div>
				</div>

				<div class="has_tbody" v-for="item, index in 4" :key="index">
					<div class=" table_row_top">
						<div class="flexween">
							<div>
								<span>订单号：300002450665 </span>
								<span class="ml20"> 申请时间：2022-05-19 14:14:02</span>
							</div>
							<div class="cur_brand detail">查看详情</div>
						</div>
					</div>
					<div class="table_cell table_row_bottom">
						<div class="tableimgbx">
							<el-checkbox class="ml20" v-model="checked"></el-checkbox>
							<el-image fit="cover" :src="src"></el-image>
							<span>孙悟空之三打白骨精孙悟空之三打白骨精孙悟空之三打白骨精孙悟空之三打白骨精</span>
						</div>
						<div class="table_cell">
							<div class="cell">夏致远</div>
						</div>
						<div class="table_cell">
							<div class="cell">美术作品</div>
						</div>
						<div class="table_cell">
							<div class="cell">待缴费</div>
						</div>

						<div class="table_cell">
							<el-button type="primary" icon="el-icon-edit-outline" size="mini" plain>编辑</el-button>
							<el-button type="primary" icon="el-icon-edit" size="mini" plain>修改</el-button>
							<!-- 待受理时 -->
							<el-button type="primary" icon="el-icon-refresh-left" size="mini" plain
								@click="undoClick(1)">
								撤销</el-button>
							<!-- 已受理时 -->
							<el-button type="primary" icon="el-icon-refresh-left" size="mini" plain
								@click="undoClick(2)">
								撤销</el-button>
							<el-button type="primary" @click="payBtnClick" icon="el-icon-goods" size="mini" plain>立即支付
							</el-button>
							<el-button type="primary" icon="el-icon-upload2" size="mini" plain>上传材料</el-button>
							<el-button type="primary" icon="el-icon-reading" size="mini" plain>查看证书</el-button>
							<el-button type="primary" icon="el-icon-search" size="mini" plain>查看原因</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="mt20 flexween">
				<el-checkbox v-model="checked">已选 2 笔</el-checkbox>
				<div>
					<span>共计：￥299</span>
					<span class="ml20">
						<el-button type="primary">立即支付</el-button>
					</span>
				</div>
			</div>
			<div class="mt20 u-text-center">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="100" layout="prev, pager, next" :total="1000">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="撤销原因" :visible.sync="undoDialogOne" width="450px" :close-on-click-modal="false">
			<div class="undobx">
				<i class="el-icon-warning"></i>
				<div>
					<div class="diaspan">确定要撤销订单吗？</div>系统正在为您加急处理， 请耐心等待…
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="undoDialog = true">撤销</el-button>
				<el-button size="small" type="primary" @click="undoDialogOne = false">暂不撤销</el-button>
			</span>
		</el-dialog>

		<el-dialog title="撤销原因" :visible.sync="undoDialogOk" width="450px" :close-on-click-modal="false">
			<div class="undobx">
				<i class="el-icon-warning"></i>
				<div>
					<div class="diaspan">
						违约撤销订单将收取您额外费用！
					</div>
					您的登记信息已经提交至版权局审核，由于您个人原因，强制撤销订单将收取您50元取消费（其中包含物料申请，邮寄等受理成本费用），是否仍然撤销？
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="undoDialog = true">撤销</el-button>
				<el-button size="small" type="primary" @click="undoDialogOk = false">继续等待</el-button>
			</span>
		</el-dialog>

		<el-dialog title="撤销订单" :visible.sync="undoDialogOrder" width="450px" :close-on-click-modal="false">
			<div class="undobx">
				<i class="el-icon-warning"></i>

				<div><span class="diaspan">订单撤销成功！</span><br>
					<el-link :underline="false">查看退款进度 ></el-link>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="undoDialogOrder = false">取消</el-button>
				<el-button size="small" type="primary" @click="undoDialogOrder = false">确定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="作品著作权登记缴费通知" :visible.sync="payDialog" width="700px" :close-on-click-modal="false">
			<div class="">
				<div class="dia_tips_span"><span>订单编号</span><i class="d-gray">2022Z11L0090903</i></div>
				<div class="dia_tips_span"><span>作品名称</span><i class="d-gray">蜘蛛精</i></div>
				<div class="dia_tips_span"><span>登记类型</span><i class="d-gray">作品著作权登记</i></div>
				<div class="dia_tips_span"><span>申请人</span><i class="d-gray">视点文化传播有限公司</i></div>
				<div class="dia_tips_span"><span>缴费时间</span><i class="d-gray">2022年05月05日</i></div>
				<div class="mt20">
					上述作品著作权登记申请材料已收到，现已通过初步审核，为了及时受理您提交的登记申请，请您尽快按照下面的费用清单缴纳费用。
				</div>
				<div class="mt20">
					<div class="dia_tips_span"><span>著作权登记费</span><i>￥280.00</i></div>
					<div class="dia_tips_span"><span>邮寄费</span><i>￥280.00</i></div>
				</div>
				<div class="hr"></div>
				<div class="u-text-right mt20">
					<div class="dia_tips_span"><span class="pts">合计：</span><i>￥280.00</i></div>
					<div class="dia_tips_span"><span class="pts">预支付金额抵扣：</span><i>￥80.00</i></div>
					<div class="dia_tips_span"><span class="pts">实付金额：</span><i>￥280.00</i></div>

				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="payDialog = false">取消</el-button>
				<el-button size="small" type="primary" @click="$router.push('/submit')">立即支付</el-button>
			</span>
		</el-dialog>

		<el-dialog title="待递交补正材料" :visible.sync="suffDialog" width="600px" :close-on-click-modal="false">
			<div class="">
				<div class="dia_tips_span"><span>订单编号</span><i class="d-gray">2022Z11L0090903</i></div>
				<div class="dia_tips_span"><span>作品名称</span><i class="d-gray">蜘蛛精</i></div>
				<div class="dia_tips_span"><span>登记类型</span><i class="d-gray">作品著作权登记</i></div>
				<div class="dia_tips_span"><span>申请人</span><i class="d-gray">视点文化传播有限公司</i></div>
				<div class="dia_tips_span"><span>缴费时间</span><i class="d-gray">2022年05月05日</i></div>
				<div class="mt20">
					上述作品著作权登记申请材料已收到，现已通过初步审核，为了及时受理您提交的登记申请，请您尽快按照下面的费用清单缴纳费用。
				</div>
				<div class="mt20">
					<div class="dia_tips_span"><span>上传材料</span></div>
					<div class="dia_tips_span">
						<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
							:show-file-list="false" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="imageUrl" :src="imageUrl" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</div>
					<div>请上传jpg、png、jpeg、pdf格式</div>
					<el-input placeholder="填写需补正的内容" class="mt20"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="suffDialog = false">取消</el-button>
				<el-button size="small" type="primary" @click="suffDialog = false">提交</el-button>
			</span>
		</el-dialog>

		<el-dialog title="撤销原因" :visible.sync="undoDialog" width="500px" :close-on-click-modal="false">
			<div class="h3">请您选择取消原因帮助我们改进吧：</div>
			<div class="mt10">撤销原因</div>
			<div class="mt10">
				<span class="edit_span" v-for="(item,index) in 10" @click="undoPopSpan(index)"
					:class="{editCur:index==undoIndex}">1111</span>
			</div>
			<div>
				<el-input v-model="input" placeholder="反馈您的意见" type="textarea" rows="4"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="aaaa">取 消</el-button>
				<el-button size="small" type="primary" @click="aaaa">提 交</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: 'worklist',
		components: {},
		data() {
			return {
				undoIndex: -1,
				input: '',
				suffDialog: false,
				undoDialogOne: false,
				undoDialogOk: false,
				undoDialogOrder: false,
				undoDialog: false,
				payDialog: false,
				src: '',
				tabIndex: 3,
				tabArr: [{
					title: '全部',
					num: 0,
				}, {
					title: '草稿箱',
					num: 0,
				}, {
					title: '待受理',
					num: 10,
				}, {
					title: '版权局审核中',
					num: 0,
				}, {
					title: '代缴费',
					num: 0,
				}, {
					title: '待补证',
					num: 0,
				}, {
					title: '已发放',
					num: 0,
				}, {
					title: '初审未通过',
					num: 0,
				}, {
					title: '已取消',
					num: 0,
				}],
				// -------------------

				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				currentPage: 2,
				ruleForm: {
					value1: '',
					input: '',
					value: '',
				},
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				checked: false
			}

		},
		created() {},
		methods: {
			payBtnClick() {
				this.payDialog = true
			},
			//撤销
			undoClick(i) {
				if (i == 1) {
					// 待受理时
					this.undoDialogOne = true
				} else {
					// 已受理时
					this.undoDialogOk = true
				}
			},

			tabliClick(i) {
				this.tabIndex = i
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			//重置
			resetForm() {
				console.log(this.$refs['ruleForm']);
				this.$refs['ruleForm'].resetFields();
			},
			undoPopSpan(index) {
				this.undoIndex = index
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.dia_tips_span {
		margin-top: 2px;

		span {
			display: inline-block;
			width: 100px;
		}

		span.pts {
			width: 120px;
		}
	}

	.table_header {
		background-color: #EBEEF5;
		padding: 10px 0;
		display: flex;
		text-align: center;

		.workname {
			width: 440px;
		}

		.table_cell {
			flex: 1;

		}
	}

	.diaspan {
		font-size: 16px;
	}

	.has_tbody {
		margin-top: 20px;

		.table_row_top {
			background-color: #EBEEF5;
			padding: 10px 14px;

			.detail {
				width: 150px;
				text-align: center;
			}
		}

		.table_row_bottom {
			display: flex;
			align-items: center;
			border: 1px solid var(--border);
			padding: 20px 0;

			.tableimgbx {
				display: flex;
				align-items: center;
				width: 440px;

				span {
					flex: 1;
					padding-right: 20px;
				}

				.el-image {
					width: 80px;
					height: 100px;
					border-radius: 4px;
					margin: 0 16px;
				}
			}

			.table_cell {
				flex: 1;
				text-align: center;

				.el-button {
					display: block;
					margin: 10px auto;
				}
			}
		}
	}


	.undobx {
		display: flex;

		i {
			font-size: 40px;
			color: var(--brand);
			margin-right: 20px;
		}
	}

	.serchbx {
		display: flex;
		justify-content: space-around;

		.serchcn {
			flex: 1;

			.el-range-editor.el-input__inner,
			.el-input,
			.el-select {
				width: 290px;
			}
		}
	}

	.workul {
		display: flex;
		justify-content: space-around;
		border-bottom: 1px solid var(--border);

		.licur {
			color: var(--brand);
			border-bottom: 2px solid var(--brand);
		}

		li {
			text-align: center;
			position: relative;
			cursor: pointer;
			line-height: 38px;

			&:hover {
				color: var(--brand);
				border-bottom: 2px solid var(--brand);
			}

			.num {
				position: absolute;
				background: var(--brand);
				color: var(--white);
				top: -8px;
				height: 20px;
				line-height: 20px;
				padding: 0px 7px;
				font-size: 12px;
				border-radius: 12px;
				right: -24px;
			}
		}
	}

	/deep/ .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		margin-top: 10px;
	}

	/deep/ .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 158px;
		height: 158px;
		line-height: 158px;
		text-align: center;
	}

	.avatar {
		width: 158px;
		height: 158px;
		display: block;
	}
</style>
